import axios from 'axios';
/* import { Auth } from 'aws-amplify';
import { Redirect } from 'react-router-dom'; */

/* const SignOut = () => {
  localStorage.removeItem('@Claro-Catalogo:token');
  localStorage.removeItem('@Claro-Catalogo:user');
  localStorage.removeItem('@Claro-Catalogo:result');
  localStorage.removeItem('_grecaptcha');

  try {
    Auth.signOut();
    <Redirect to={{ pathname: '/login' }} />;
  } catch (error) {
    console.log('error signing out: ', error);
  }
}; */

const getSearch = async (index, text) => {
  const isLocal = window.location.hostname === 'localhost';
  const fakeGateway = '/data/fakeData.json';

  const options = {
    method: 'GET',
    url: isLocal ? fakeGateway : process.env.REACT_APP_AWS_URL_API_GATEWAY,
    params: { q1: index, q2: text },
    headers: {
      token: localStorage.getItem('@Claro-Catalogo:token'),
    },
  };

  return axios
    .request(options)
    .then((response) => response)
    .catch((error) => {
      // Se erro de login, redireciona /login e limpa token velho do localStorage
      // if(error && error.response && error.response.status === 401) { // unauthorized
      localStorage.removeItem('@Claro-Catalogo:token');
      window.location.href = '/login'; // force clean states
      // }
      console.error(error);
    });
};

// Interceptor Request
/* axios.interceptors.request.use(async (config) => {
  return new Promise((resolve, reject) => {
    Auth.currentSession()
      .then((session) => {
        const idTokenExpire = session.getIdToken().getExpiration();
        const currentTimeSeconds = Math.round(+new Date() / 1000);

        if (idTokenExpire < currentTimeSeconds) {
          SignOut();
        }

        resolve(config);
      })
      .catch((error) => {
        console.log(error);
        SignOut();
        resolve(config);
      });
  });
}); */

export default getSearch;
